import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'feedBait_mng',
  components: {
    feedBaitTable: function feedBaitTable() {
      return import('./feedBait_page');
    },
    feedRecordTable: function feedRecordTable() {
      return import('./feedBait_feedRecord_page');
    },
    smartControlItemTable: function smartControlItemTable() {
      return import('../smartControl/smartControlItem_page');
    },
    smartControlCmdTable: function smartControlCmdTable() {
      return import('../smartControl/smartControlCmd_page');
    },
    smartControlLogTable: function smartControlLogTable() {
      return import('../smartControl/smartControlLog_page');
    },
    smartControlTLogTable: function smartControlTLogTable() {
      return import('../smartControl/smartControlTLog_page');
    },
    smartControlTLogAnalysis: function smartControlTLogAnalysis() {
      return import('../smartControl/smartControl_analysis');
    },
    smartControlRuleTable: function smartControlRuleTable() {
      return import('../smartControl/smartControlRule_page');
    },
    smartControlWarnLogTable: function smartControlWarnLogTable() {
      return import('../smartControl/smartControlWarnLog_page');
    },
    smartControlTaskTable: function smartControlTaskTable() {
      return import('../smartControl/smartControlTask_page');
    }
  },
  data: function data() {
    return {
      tableShow: 'feedBait',
      current: {},
      prev: {}
    };
  },
  methods: {
    gofeedBait: function gofeedBait() {
      this.tableShow = 'feedBait';
    },
    goChild: function goChild(data, tableName) {
      this.current = data;
      this.tableShow = tableName;
    }
  }
};